import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from 'abs-ngx-library/src/lib/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

function LoyaltyNonDigitalCouponCardAlV1Component_button_22_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function LoyaltyNonDigitalCouponCardAlV1Component_button_22_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.addToList()); });
    i0.ɵɵelement(1, "span", 18);
    i0.ɵɵelementEnd();
} }
function LoyaltyNonDigitalCouponCardAlV1Component_button_23_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function LoyaltyNonDigitalCouponCardAlV1Component_button_23_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeFromList()); });
    i0.ɵɵelement(1, "span", 20);
    i0.ɵɵelementEnd();
} }
class LoyaltyNonDigitalCouponCardAlV1Component {
    constructor(_offerDetailService, _userInfoService, _utilService, _productUtilService, myListService, elementRef) {
        this._offerDetailService = _offerDetailService;
        this._userInfoService = _userInfoService;
        this._utilService = _utilService;
        this._productUtilService = _productUtilService;
        this.myListService = myListService;
        this.elementRef = elementRef;
        this.myListItems = [];
        this.openFlyOutEvent = new EventEmitter();
        this.configObj = {};
    }
    ngOnInit() {
        this._offerDetailService.couponUpdated.subscribe((data) => {
            if (data && Object.keys(data).length && data['offerId'] === this.cmsCardData.offerId) {
                this.cmsCardData.deleted = data['deleted'];
                this.cmsCardData.status = data['status'];
            }
        });
    }
    createDateString() {
        const startDate = new Date(Number(this.cmsCardData.startDate));
        const endDate = new Date(Number(this.cmsCardData.endDate));
        const numeric = { month: 'numeric', day: 'numeric' };
        return `${startDate.toLocaleDateString('en-US', numeric)} - ${endDate.toLocaleDateString('en-US', numeric)}`;
    }
    onClickEvent() {
        this.openFlyOutEvent.emit(this.cmsCardData);
    }
    trackAnalyticsClicks(source) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            const sectionTitle = window['AB']['DATALAYER'].sanitizeAnalyticsText(window['AB']['DATALAYER'].getAnalyticsCarouselTitle(this.elementRef.nativeElement));
            window['AB']['DATALAYER'].setLinkClickEvents(`weekly-ad${source === 'eligible-items' || source === 'offer-details'
                ? `:${sectionTitle}`
                : ''}${source ? `|${source}` : ''}`, false, `${source === 'add-to-list' ? `weekly-ad:${sectionTitle}` : ''}`);
        }
    }
    setCookie(name, value) {
        document.cookie = `${name}=${value}; max-age=600; path=/; domain=${window['AB']['userInfo']['banner']}.com`;
    }
    addToList() {
        if (this._utilService.isTokenActive() && this._userInfoService.isAuthorized()) {
            const payload = {
                "items": [{
                        clipType: 'L',
                        itemId: this.cmsCardData.offerId,
                        itemType: this.cmsCardData.offerPgm,
                        wsSource: this.cmsCardData.source,
                    }]
            };
            this._offerDetailService.addToList(payload).subscribe(response => {
                if (response && response['items'] && response['items'][0] && response['items'][0]['status'] === 1) {
                    this.cmsCardData.status = 'C';
                    this.cmsCardData.deleted = false;
                    this.myListService.getMyList(window['AB'].userInfo.branchId, true).subscribe((mylist) => {
                        // console.warn('weekly-ad mylist: ' + JSON.stringify(mylist));
                        if (mylist && mylist.shoppingLists && mylist.shoppingLists[0] && mylist.shoppingLists[0].items) {
                            this.myListItems = [...[], ...mylist.shoppingLists[0].items];
                        }
                    });
                    this._offerDetailService.couponUpdated.next({ ...this.cmsCardData, status: 'C', deleted: false });
                }
            });
            this.trackAnalyticsClicks('add-to-list');
        }
        else {
            const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
            this.setCookie('ACI_S_ECommRedirectURL', encodeURIComponent(window.location.href));
            const navPath = bannerDomainUrl + window['AB'].signInLinkPath;
            const analyticsIcmpid = window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].trackWeeklyAdIcmpid && window['AB']['DATALAYER'].trackWeeklyAdIcmpid('add-to-list', navPath) || '';
            window.location.assign(navPath + `${analyticsIcmpid}`);
            return;
        }
    }
    removeFromList() {
        if (this._utilService.isTokenActive() && this._userInfoService.isAuthorized()) {
            const items = [];
            if (this.myListItems != null) {
                this.myListItems.forEach(element => {
                    if (element.referenceId == this.cmsCardData.offerId) {
                        items.push({ id: element.id });
                    }
                });
            }
            const payload = {
                "items": items
            };
            this._offerDetailService.removeFromList(payload).subscribe(response => {
                if (response && response['items'] && response['items'][0]) {
                    this.cmsCardData.deleted = true;
                    this._offerDetailService.couponUpdated.next({ ...this.cmsCardData, status: 'C', deleted: true });
                }
            });
            this.trackAnalyticsClicks('remove-from-list');
        }
        else {
            const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
            this.setCookie('ACI_S_ECommRedirectURL', encodeURIComponent(window.location.href));
            window.location.assign(bannerDomainUrl + window['AB'].signInLinkPath);
            return;
        }
    }
    static { this.ɵfac = function LoyaltyNonDigitalCouponCardAlV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoyaltyNonDigitalCouponCardAlV1Component)(i0.ɵɵdirectiveInject(i1.OfferDetailService), i0.ɵɵdirectiveInject(i1.UserInfoService), i0.ɵɵdirectiveInject(i1.UtilService), i0.ɵɵdirectiveInject(i1.ProductUtilService), i0.ɵɵdirectiveInject(i1.MylistService), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoyaltyNonDigitalCouponCardAlV1Component, selectors: [["loyalty-non-digital-coupon-card-al-v1"]], inputs: { cmsCardData: "cmsCardData", cardIndex: "cardIndex", myListItems: "myListItems" }, outputs: { openFlyOutEvent: "openFlyOutEvent" }, decls: 24, vars: 11, consts: [[1, "cms-coupon-card", "card", "col"], [1, "cms-coupon-card__card-body"], [1, "row", "mb-4"], [1, "col-8"], [1, "card-title"], [1, "coupon-title", "text-truncate", 3, "title"], [1, "coupon-details", "text-truncate", 3, "title"], [1, "cms-coupon-card-offer-details-container"], ["role", "link", 1, "cms-coupon-card-offer-details", "offer-details", 3, "click"], [1, "col-4"], [1, "w-100", "product-image", 3, "src", "alt"], [1, "py-3", "d-flex"], [1, "flex-grow-1"], ["aria-label", "button", 1, "btn", "btn-md", "pds-btn-filled--primary", "w-100", 3, "click"], [1, "ml-3"], ["type", "button", "class", "btn btn-secondary btn-circle--md", "aria-label", "Add to List", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn btn-secondary btn-circle--md", "aria-label", "Added to List", 3, "click", 4, "ngIf"], ["type", "button", "aria-label", "Add to List", 1, "btn", "btn-secondary", "btn-circle--md", 3, "click"], [1, "svg-icon", "svg-add-to-list-icon"], ["type", "button", "aria-label", "Added to List", 1, "btn", "btn-secondary", "btn-circle--md", 3, "click"], [1, "svg-icon", "svg-added-to-list-icon"]], template: function LoyaltyNonDigitalCouponCardAlV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 5);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 6);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 7)(11, "a", 8);
            i0.ɵɵlistener("click", function LoyaltyNonDigitalCouponCardAlV1Component_Template_a_click_11_listener() { ctx.onClickEvent(); return ctx.trackAnalyticsClicks("offer-details"); });
            i0.ɵɵtext(12, "Offer Details");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "span");
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(15, "div", 9);
            i0.ɵɵelement(16, "img", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 11)(18, "div", 12)(19, "button", 13);
            i0.ɵɵlistener("click", function LoyaltyNonDigitalCouponCardAlV1Component_Template_button_click_19_listener() { ctx.onClickEvent(); return ctx.trackAnalyticsClicks("eligible-items"); });
            i0.ɵɵtext(20, "Eligible Items");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(21, "div", 14);
            i0.ɵɵtemplate(22, LoyaltyNonDigitalCouponCardAlV1Component_button_22_Template, 2, 0, "button", 15)(23, LoyaltyNonDigitalCouponCardAlV1Component_button_23_Template, 2, 0, "button", 16);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.cmsCardData == null ? null : ctx.cmsCardData.forUDescription, " ");
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("title", ctx.cmsCardData == null ? null : ctx.cmsCardData.brand);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.cmsCardData == null ? null : ctx.cmsCardData.brand, " ");
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("title", ctx.cmsCardData == null ? null : ctx.cmsCardData.ecomDescription);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.cmsCardData == null ? null : ctx.cmsCardData.ecomDescription, " ");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" . ", ctx.createDateString(), "");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("src", "http://s7d2.scene7.com/is/image/ABS/", ctx.cmsCardData == null ? null : ctx.cmsCardData.imageId, "?$ecom-product-card-desktop$&defaultImage=Not_Available", i0.ɵɵsanitizeUrl);
            i0.ɵɵpropertyInterpolate("alt", ctx.cmsCardData == null ? null : ctx.cmsCardData.brand);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", (ctx.cmsCardData == null ? null : ctx.cmsCardData.status) === "U" || (ctx.cmsCardData == null ? null : ctx.cmsCardData.deleted));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.cmsCardData == null ? null : ctx.cmsCardData.status) === "C" && !(ctx.cmsCardData == null ? null : ctx.cmsCardData.deleted));
        } }, dependencies: [i2.NgIf] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoyaltyNonDigitalCouponCardAlV1Component, [{
        type: Component,
        args: [{ selector: 'loyalty-non-digital-coupon-card-al-v1', template: "<div class=\"cms-coupon-card card col\">\n    <div class=\"cms-coupon-card__card-body\">\n        <div class=\"row mb-4\">\n            <div class=\"col-8\">\n                <div class=\"card-title\">\n                    {{ cmsCardData?.forUDescription }}\n                </div>\n                <div class=\"coupon-title text-truncate\" title=\"{{ cmsCardData?.brand }}\">\n                    {{ cmsCardData?.brand }}\n                </div>\n                <div class=\"coupon-details text-truncate\" title=\"{{ cmsCardData?.ecomDescription }}\">\n                    {{ cmsCardData?.ecomDescription }}\n                </div>\n                <div class=\"cms-coupon-card-offer-details-container\">\n                    <a class=\"cms-coupon-card-offer-details offer-details\" role=\"link\" (click)=\"onClickEvent(); trackAnalyticsClicks('offer-details')\">Offer Details</a> <span> . {{ createDateString() }}</span>\n                </div>\n            </div>\n            <div class=\"col-4\">\n                <img class=\"w-100 product-image\" src=\"http://s7d2.scene7.com/is/image/ABS/{{ cmsCardData?.imageId }}?$ecom-product-card-desktop$&amp;defaultImage=Not_Available\" alt=\"{{ cmsCardData?.brand }}\">\n            </div>\n        </div>\n        <div class=\"py-3 d-flex\">\n            <div class=\"flex-grow-1\">\n                <button class=\"btn btn-md pds-btn-filled--primary w-100\" aria-label=\"button\" (click)=\"onClickEvent(); trackAnalyticsClicks('eligible-items')\">Eligible Items</button>\n            </div>\n            <div class=\"ml-3\">\n                <button *ngIf=\"cmsCardData?.status === 'U' || cmsCardData?.deleted\" type=\"button\" class=\"btn btn-secondary btn-circle--md\" aria-label=\"Add to List\" (click)=\"addToList()\">\n                    <span class=\"svg-icon svg-add-to-list-icon\"></span>\n                </button>\n                <button *ngIf=\"cmsCardData?.status === 'C' && !cmsCardData?.deleted\" type=\"button\" class=\"btn btn-secondary btn-circle--md\" aria-label=\"Added to List\" (click)=\"removeFromList()\">\n                    <span class=\"svg-icon svg-added-to-list-icon\"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
    }], () => [{ type: i1.OfferDetailService }, { type: i1.UserInfoService }, { type: i1.UtilService }, { type: i1.ProductUtilService }, { type: i1.MylistService }, { type: i0.ElementRef }], { cmsCardData: [{
            type: Input
        }], cardIndex: [{
            type: Input
        }], myListItems: [{
            type: Input
        }], openFlyOutEvent: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LoyaltyNonDigitalCouponCardAlV1Component, { className: "LoyaltyNonDigitalCouponCardAlV1Component", filePath: "loyalty-non-digital-coupon-card-al-v1/loyalty-non-digital-coupon-card-al-v1.component.ts", lineNumber: 26 }); })();

class LoyaltyNonDigitalCouponCardModule {
    static { this.ɵfac = function LoyaltyNonDigitalCouponCardModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoyaltyNonDigitalCouponCardModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LoyaltyNonDigitalCouponCardModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoyaltyNonDigitalCouponCardModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LoyaltyNonDigitalCouponCardAlV1Component
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    LoyaltyNonDigitalCouponCardAlV1Component
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LoyaltyNonDigitalCouponCardModule, { declarations: [LoyaltyNonDigitalCouponCardAlV1Component], imports: [CommonModule], exports: [LoyaltyNonDigitalCouponCardAlV1Component] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LoyaltyNonDigitalCouponCardAlV1Component, LoyaltyNonDigitalCouponCardModule };
